import { createEmIcon } from '../designSystemIcons';

export const SignatureIcon = createEmIcon('signature');
